<template>
    <modal :active="active" :close="closeWrapper">
        <slot></slot>
        <div class="m-t-lg">
            <loading v-if="loading"></loading>
            <div class="buttons is-centered" v-show="!loading">
                <button class="button" @click="callback(false)">
                    {{this.noText}}
                </button>
                <button class="button is-danger" @click="callback(true)">
                    {{this.yesText}}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name : "ConfirmModal",
    props : {
        active : {
            type : Boolean,
            required : true,
        },
        close : {
            type : Function,
            required : true
        },
        callback : {
            type : Function,
            required : true,
        },
        loading : {
            type : Boolean,
            required : true,
        },
        yesText : {
            type : String,
            required : false,
            default : 'YES',
        },
        noText : {
            type : String,
            required : false,
            default : 'NO',
        },
    },
    methods : {
        closeWrapper () {
            if(this.loading){
                return;
            }
            this.close();
        },
    },
}
</script>

<style lang="scss" scoped>
    .button {
        min-width:180px;
    }
</style>
